import { NavigationGuard } from "vue-router"
import router from "@/router"

export const ensureVisitReasonPresence: NavigationGuard = (to, _from, _next) => {
  if (!to.query.visitReasonId) {
    router.push({ name: "home" }).then()
    return false
  }
  return true
}
